
<div class="nsw-container"  style="margin-bottom: 32px;"> 

    <div class="nsw-layout">
        <main class="nsw-block">
            <h1>Water quality data</h1>
            <p class="nsw-intro">
                The water quality data collected under the Beachwatch program can be viewed or downloaded. Results are usually updated within one week of sample collection.
                <br/><br/>
                Our quality assurance program ensures that the information collected and reported by Beachwatch and our partners is accurate and reliable.
                <br/><br/>
                Learn more about our <app-external-link text="quality assurance program" link="https://www.environment.nsw.gov.au/publications/ensuring-confidence-beachwatch-water-quality-results" [isExternalLink]="true"></app-external-link>
            </p>
                    
        
            <form [formGroup]="downloadDataForm" class="nsw-form full-width">
                
                <div class="nsw-form__group">
                    <fieldset class="nsw-form__fieldset">
                        <legend>
                            <span class="nsw-form__legend nsw-form__required">
                                Category
                                <span class="sr-only"> (required)</span>
                            </span>                    
                        </legend> 
                        <div class="checkboxes">
                            <input id="downloadDataTypeWaterTemp"
                                class="nsw-form__radio-input" 
                                type="radio" 
                                name="downloadDatatype" 
                                [value]="DOWNLOAD_DATATYPES[0]"
                                formControlName="downloadDatatype"
                                [tabIndex]="0" />
                            <label class="nsw-form__radio-label" for="downloadDataTypeWaterTemp">{{DOWNLOAD_DATATYPES[0]}}</label>
                        
                            <input id="downloadDataTypeAnnualGrade"
                                class="nsw-form__radio-input" 
                                type="radio" 
                                name="downloadDatatype" 
                                [value]="DOWNLOAD_DATATYPES[1]"
                                formControlName="downloadDatatype" />
                            <label class="nsw-form__radio-label" for="downloadDataTypeAnnualGrade">{{DOWNLOAD_DATATYPES[1]}}</label>               
                        </div>               
                        <!-- Not required, no way to unselect both the options clear will reset the control -->
                        <span *ngIf="downloadDatatype?.touched && !downloadDatatype?.valid"                     
                            class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            This field is required
                        </span> 
                    </fieldset>
                </div>       
            
                <ng-container *ngIf="DOWNLOAD_DATATYPES[0] === downloadDatatype?.value">
                    <div class="nsw-form__group" formArrayName="downloadDataCategories">
                        <fieldset class="nsw-form__fieldset">
                            <legend>
                                <span class="nsw-form__legend">
                                    Data categories
                                    <span class="sr-only"></span>
                                </span> 
                            </legend> 
                            <div class="checkboxes">
                                <input class="nsw-form__checkbox-input" 
                                    type="checkbox" name="downloadDataCategory" 
                                    [id]="'filterByDataCategory' + DATA_CATEGORIES[0]"
                                    [formControlName]="0"
                                    [tabIndex]="0"
                                    />
                                <label class="nsw-form__checkbox-label" 
                                    [for]="'filterByDataCategory' + DATA_CATEGORIES[0]">
                                    {{DATA_CATEGORIES[0]}}
                                </label>

                                <input class="nsw-form__checkbox-input" 
                                    type="checkbox" name="downloadDataCategory" 
                                    [id]="'filterByDataCategory' + DATA_CATEGORIES[1]"
                                    [formControlName]="1" />
                                <label class="nsw-form__checkbox-label" 
                                    [for]="'filterByDataCategory' + DATA_CATEGORIES[1]">
                                    {{DATA_CATEGORIES[1]}}
                                </label>

                                <input class="nsw-form__checkbox-input" 
                                    type="checkbox" name="downloadDataCategory" 
                                    [id]="'filterByDataCategory' + DATA_CATEGORIES[2]"
                                    [formControlName]="2" />
                                <label class="nsw-form__checkbox-label" 
                                    [for]="'filterByDataCategory' + DATA_CATEGORIES[2]">
                                    {{DATA_CATEGORIES[2]}}
                                </label>
                            </div>                   
                        </fieldset>
                    </div>
                    <div class="frame-693">
                        <div class="separator"></div>
                    </div>
                </ng-container> 

                <ng-container *ngIf="downloadDatatype?.value">

                    <ng-container *ngIf="downloadDatatype?.value">
                        <app-region-council-beach-sites-selection                  
                            #regionCouncilBeachSiteSelector
                            [required]="true"
                            [preSelectedCouncil]="selectedCouncil ?? ''"               
                            [formGroup]="downloadDataForm"
                            [allBeachSites]="allBeachSites"
                            [allRegions]="allRegions"
                            [allCouncils]="allCouncils" >
                        </app-region-council-beach-sites-selection>
                    </ng-container>   
                        
                    <ng-container *ngIf="DOWNLOAD_DATATYPES[1] === downloadDatatype?.value">
                        <div class="nsw-form__group" formArrayName="selectedYears">
                            <fieldset class="nsw-form__fieldset">
                                <legend>
                                    <span class="nsw-form__legend nsw-form__required">
                                        Select one or more from the list below
                                        <span class="sr-only"></span>
                                    </span>                    
                                </legend>                    
                                <div class="list-container">
                                    <ng-container *ngFor="let year of selectedYears?.controls; let i = index">
                                        <input class="nsw-form__checkbox-input" 
                                            type="checkbox" name="selectedYears"
                                            [formControlName]="i" 
                                            [id]="'year-' + annualgradeYears?.[i]"
                                            (change)="onUpdateFreqSelectedYearChange($event)"  />
                                        <label class="nsw-form__checkbox-label" 
                                            [for]="'year-' + annualgradeYears?.[i]">
                                            {{annualgradeYears?.[i]}}
                                        </label>                          
                                    </ng-container>                                 
                                </div>
                                <div class="clear-selections">
                                    <a 
                                        href="javascript:void(0)"
                                        (click)="clearAllSelectedYears(false)"                                         
                                        role="button"
                                        class="nsw-link nsw-link--icon" >Clear all selections</a>
                                    <a (click)="selectAllYears()" 
                                        href="javascript:void(0)"                                        
                                        [tabindex]="0"
                                        role="button"
                                        class="nsw-link nsw-link--icon" >Select all</a>
                                </div> 
                                <span *ngIf="selectedYears?.touched && !selectedYears?.valid" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper">
                                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                                    Please select atleast one option
                                </span>
                            </fieldset>
                        </div> 
                                
                    </ng-container>

                    <div class="frame-693">
                        <div class="separator"></div>
                    </div>
                </ng-container>          
                    
                <ng-container *ngIf="DOWNLOAD_DATATYPES[0] === downloadDatatype?.value">
                    <div class="dates-section">                
                        <app-custom-date-widget #fromDate
                            [formGroup]="downloadDataForm" 
                            dateGroupName="fromDate"
                            (dateChanged)="onDateChanged($event)"
                            label="Date from:">
                        </app-custom-date-widget>
                        
                        <app-custom-date-widget #toDate
                            [formGroup]="downloadDataForm" 
                            dateGroupName="toDate"
                            (dateChanged)="onDateChanged($event)"
                            label="Date to:">
                        </app-custom-date-widget>                
                    </div>                    
                    <span *ngIf="fromDateToDateError.error"                     
                        class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper">
                        <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                        {{fromDateToDateError.message}}
                    </span> 

                </ng-container>
            
                <span *ngIf="noData"                     
                    class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper">
                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                    No data available for the selected parameters, please refine your query and try again.
                </span> 
            

                <div class="nsw-form__group">  
                    <a 
                        href="javascript:void(0)"
                        (click)="clearAllFilters()"                         
                        role="button"
                        class="nsw-link nsw-link--icon"
                        aria-haspopup="dialog">Clear all filters</a>                  
                    <!-- <div class="nsw-list nsw-list--8" (click)="clearAllFilters()">
                        <span class="reset">Clear all filters</span>
                    </div> -->
                    <div class="nsw-list nsw-list--8" style="margin-top:24px;">
                        <button type="button" 
                            class="nsw-button nsw-button--dark-outline-solid"
                            (click)="onDownloadDataClicked()"                    
                            [disabled]="!isFormValid || processing">
                            Download data
                        </button>
        
                        <button type="button" class="nsw-button nsw-button--dark"
                            [disabled]="!isFormValid || processing"
                            (click)="onViewDataClicked()">View data</button>                          
                    </div>
                </div>
            </form>            

            <ng-container *ngIf="viewData"> 
                <div class="frame-693">
                    <div class="separator"></div>
                </div>

                <div class="frame-2221">
                    <app-datatable
                        [tableDefinition]="tableDefinition">
                    </app-datatable>
                </div>                
            </ng-container>
        </main>
    </div> 
</div>

    